import { useMsal } from '@azure/msal-react';
import { AuthHelper } from '../auth/AuthHelper';
import { News, NewsService } from '../services/NewsService';

export const useNews = () => {
    const { instance, inProgress } = useMsal();
    const newsService = new NewsService();

    const save = async (news: News) => {
        const accessToken = await AuthHelper.getSKaaSAccessToken(instance, inProgress);

        if (news.id && news.id.trim() !== '') {
            await newsService.update(news, accessToken);
        } else {
            await newsService.save(news, accessToken);
        }
    };

    const load = async () => {
        return await newsService.load(await AuthHelper.getSKaaSAccessToken(instance, inProgress));
    };

    const deleteNews = async (newsId: string) => {
        await newsService.delete(newsId, await AuthHelper.getSKaaSAccessToken(instance, inProgress));
    };

    return {
        save,
        load,
        deleteNews,
    };
};
